import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import Field from '../../../../fields'
import EditProfileCard, { CardFields } from '../EditProfileCard'

type CustomIdCardProps = {
  fields: Record<string, any>
  formId: string
  accountFieldsOnly?: boolean
  testId?: string
}

const CustomIdCard = ({
  fields,
  formId,
  accountFieldsOnly = false,
  testId
}: CustomIdCardProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <EditProfileCard title={t(generalConstants.CUSTOM_ID)} testId={testId}>
      <Suspense fallback={<div>Loading...</div>}>
        <CardFields>
          <Field
            className="custom-id-field"
            formId={formId}
            keys="customId"
            label={t(generalConstants.CUSTOM_ID)}
            type="text"
            note={t(generalConstants.CUSTOM_ID_DESC)}
            disabled={accountFieldsOnly}
            values={fields}
          />
        </CardFields>
      </Suspense>
    </EditProfileCard>
  )
}

export default CustomIdCard
